import React, {useEffect, useState} from 'react';
import {URLS} from "@/lib/urls";
import AdminLayout from "@/components/layout/admin/adminLayout";
import {Link, useParams} from "react-router-dom";
import {useApiGetAdminRefundsDetail, useApiPutAdminRefund} from "@/api/refund";
import RenderLoading from "@/components/render-if-loading";
import {Button, Card, Descriptions, Divider, Input, Statistic, Timeline, Typography} from "antd";
import RefundStatusEnumComponent from "@/components/EnumComponents/RefundStatusEnumComponent";
import {formatDateFull} from "@/lib/utils/date";
import {sprintf} from "@/lib/utils/sprintf";
import RenderIf from "@/components/render-if";
import CopyMe from "@/lib/helper/copyMe";
import ApiHandleSuccessMessage, {ApiHandleErrorMessage} from "@/lib/helper/apiHandleResultMessage";

function AdminEditRefundPage(props) {

    const {id} = useParams();

    const [message, setMessage] = useState('')
    const {data: refundData, isPending, refetch} = useApiGetAdminRefundsDetail({id: id})
    const {mutate: updateRefund, isPending: isPendingUpdateRefund} = useApiPutAdminRefund()

    useEffect(() => {
        setMessage(refundData?.data?.data?.message)
    }, [refundData])

    const statuses = {
        pending: 'pending',
        approved: 'approved',
        rejected: 'rejected',
        cancelled: 'cancelled',
        payed: 'payed',
    }

    function handleChangeStatus(status) {
        updateRefund({
            id: id,
            status: status,
            message: message

        }, {
            onSuccess: (r) => {
                ApiHandleSuccessMessage(r)
                refetch().then(r => {
                })
            },
            onError: (e) => {
                ApiHandleErrorMessage(e)
            }
        })
    }

    return (
        <AdminLayout pageTitle={'مشاهده درخواست بازگشت وجه'} backTo={URLS.admin.refund.items}>
            <RenderLoading loading={isPending} skeleton={true}>
                <Card className="rounded-2xl shadow-lg border-0">


                    <div className="flex flex-wrap gap-4 justify-between items-center">

                        <div>
                            <Typography.Title level={4} className="!mb-1">
                                درخواست بازگشت وجه
                                <span>#{id}</span>
                            </Typography.Title>

                            <RefundStatusEnumComponent text={refundData?.data?.data?.status}/>

                        </div>

                        <Statistic
                            className={'font-bold'}
                            title="مبلغ"
                            value={refundData?.data?.data?.amount}
                            suffix={<><span className={'text-sm text-gray-400'}>تومان</span></>}
                        />

                    </div>

                    <Divider/>


                    <Descriptions
                        bordered
                        column={1}
                    >

                        <Descriptions.Item label="کاربر">
                            <div className="flex flex-wrap gap-1">
                                {refundData?.data?.data?.useracademy?.firstname}
                                <b>{refundData?.data?.data?.useracademy?.lastname}</b>
                                <Link
                                    to={sprintf(URLS.admin.members.edit, {id: refundData?.data?.data?.useracademy?.id})}>
                                    <Button type={'link'} size={'small'} className={'text-xs'}>
                                        نمایش پروفایل
                                    </Button>
                                </Link>
                            </div>

                        </Descriptions.Item>

                        <Descriptions.Item label="تاریخ درخواست">
                            {formatDateFull(refundData?.data?.data?.date)}
                        </Descriptions.Item>

                        <Descriptions.Item label="شناسه تراکنش کسر موجودی">
                            {refundData?.data?.data?.academytransaction_id}
                        </Descriptions.Item>

                        <Descriptions.Item label="شناسه تراکنش بازگشت موجودی">
                            {refundData?.data?.data?.cancel_academytransaction_id ?? '-'}
                        </Descriptions.Item>

                        <Descriptions.Item label="گروه">
                            <RenderIf condition={refundData?.data?.data?.refund_group_id}>
                                <Link
                                    to={sprintf(URLS.admin.refund.group.edit, {id: refundData?.data?.data?.refund_group_id})}>
                                    {refundData?.data?.data?.refund_group?.title}
                                </Link>
                            </RenderIf>
                        </Descriptions.Item>


                        <Descriptions.Item label="وضعیت درخواست">
                            <RefundStatusEnumComponent text={refundData?.data?.data?.status}/>
                        </Descriptions.Item>


                    </Descriptions>

                    <Divider/>


                    <Card
                        size="small"
                        title="اطلاعات بانکی"
                    >

                        <Descriptions column={1}>
                            <Descriptions.Item label="صاحب حساب">
                                {refundData?.data?.data?.useracademy?.payment?.owner}
                            </Descriptions.Item>

                            <Descriptions.Item label="نام بانک">

                                {refundData?.data?.data?.useracademy?.payment?.bank}

                            </Descriptions.Item>

                            <Descriptions.Item label="شماره کارت">
                                <CopyMe icon={true} data={refundData?.data?.data?.useracademy?.payment?.cardnumber}>
                                    {refundData?.data?.data?.useracademy?.payment?.cardnumber}
                                </CopyMe>

                            </Descriptions.Item>

                            <Descriptions.Item label="شماره شبا">
                                <CopyMe icon={true} data={refundData?.data?.data?.useracademy?.payment?.shaba}>
                                    IR{refundData?.data?.data?.useracademy?.payment?.shaba}
                                </CopyMe>

                            </Descriptions.Item>
                        </Descriptions>

                    </Card>

                    <Divider/>

                    <RenderIf
                        condition={refundData?.data?.data?.status === statuses.cancelled || refundData?.data?.data?.status === statuses.rejected}>
                        <p className={'border border-2 dark:border-gray-600 rounded-lg p-2'}>{message}</p>
                    </RenderIf>


                    {/* Timeline */}
                    <RenderIf
                        condition={refundData?.data?.data?.status !== statuses.cancelled && refundData?.data?.data?.status !== statuses.rejected}>

                        <Timeline

                            items={[
                                {
                                    color: "black",
                                    children: "توضیحات مدیر می‌تواند شامل هر نکته یا توضیحی که میخواهید کاربر در خصوص این درخواست مطلع باشد می‌شود"
                                },
                                {
                                    color: "red",
                                    children: "در صورت لغو درخواست مبلغ کسر شده از حساب کاربری دانش آموز به ایشان برگشت داده خواهد شد و امکان ویرایش مجدد این درخواست بعد از لغو وجود نخواهد داشت"
                                },
                                {
                                    color: "blue",
                                    children: "در صورت تایید درخواست وظیفه واریز مبلغ به شماره کارت یا شبای اعلامی با شما خواهد بود",

                                },
                                {
                                    color: "green",
                                    children: "در صورتی که پرداخت کامل شده است جزئیات پرداخت را در بخش توضیحات یادداشت کرده و پرداخت کامل را بزنید"
                                }


                            ]}
                        />


                        <Typography.Title level={5}>
                            توضیحات مدیر
                        </Typography.Title>

                        <Input.TextArea
                            value={message}
                            onChange={(e) => setMessage(e.target.value)}
                            rows={5}
                            placeholder="توضیحات مربوط به این درخواست اعم از شماره تراکنش بانک یا دلیل عدم واریز و یا هر مطلب دیگر که کاربر باید در جریان آن باشد..."
                        />

                        <div className="flex flex-wrap justify-between gap-3 mt-6">


                            <Button
                                danger
                                disabled={![statuses.pending, statuses.approved].includes(refundData?.data?.data?.status)}
                                loading={isPendingUpdateRefund}
                                size="large" onClick={() => handleChangeStatus(statuses.rejected)}>
                                لغو درخواست
                            </Button>


                            <Button
                                disabled={![statuses.pending, statuses.reject, statuses.payed].includes(refundData?.data?.data?.status)}
                                onClick={() => handleChangeStatus(statuses.approved)}
                                loading={isPendingUpdateRefund}
                                type="primary"
                                size="large"
                            >
                                تایید و در انتظار پرداخت
                            </Button>


                            <Button
                                disabled={![statuses.pending, statuses.approved, statuses.reject].includes(refundData?.data?.data?.status)}
                                onClick={() => handleChangeStatus(statuses.payed)}
                                loading={isPendingUpdateRefund}
                                variant={'solid'}
                                color={'green'}
                                size="large"
                            >
                                پرداخت کامل شده
                            </Button>


                        </div>
                    </RenderIf>


                </Card>
            </RenderLoading>
        </AdminLayout>
    );
}

export default AdminEditRefundPage;